import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Button, Input } from 'ui/styled';
import { selectSkills, useContactStore } from 'stores/nic/stores/contactStore';
import { selectCalls, useCallStore } from 'stores/nic/stores/callStore';
import { useNicService } from 'stores/nic/useNicService';
import { AgentsWrapper } from './styled';
var SkillsTab = function () {
    var skills = useContactStore(selectSkills);
    var calls = useCallStore(selectCalls);
    var setShowAdditionalDirectory = useCallStore().setShowAdditionalDirectory;
    var holdCurrentAndDialSkill = useNicService().holdCurrentAndDialSkill;
    var currentCallIndex = calls.findIndex(function (c) { return c.call !== null; });
    var _a = useState(''), searchValue = _a[0], setSearchValue = _a[1];
    var skillItems = useMemo(function () {
        return skills
            .filter(function (skill) {
            if (!skill.isActive)
                return false;
            if (!searchValue)
                return true;
            return (skill.skillName || '')
                .toLowerCase()
                .includes(searchValue.toLowerCase());
        })
            .sort(function (a, b) { return (a.skillName || '').localeCompare(b.skillName || ''); });
    }, [skills, searchValue]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { paddingBottom: 8 }, children: _jsx(Input, { placeholder: "Search skills", value: searchValue, onChange: function (e) { return setSearchValue(e.target.value); } }) }), _jsx("div", { style: { overflowY: 'auto', maxHeight: 190 }, children: skillItems.length ? (skillItems.map(function (skill) { return (_jsxs(AgentsWrapper, { children: [_jsx("div", { children: skill.skillName }), _jsx(Button, { onClick: function () {
                                setShowAdditionalDirectory(false);
                                holdCurrentAndDialSkill(skill.skillId, currentCallIndex);
                            }, children: "Call" })] }, skill.skillId)); })) : (_jsx("div", { style: { padding: '8px 0 8px 8px' }, children: "No available skills" })) })] }));
};
export default SkillsTab;
